import { Group, Stack } from '@mantine/core'
import { H2 } from '@packages/ui'
import {
  IconCreditCard,
  IconUser,
  IconBell,
  IconCode,
  IconFileText,
  IconKey,
  IconLogout,
  IconDatabase,
  IconHome,
  IconBooks,
  IconToggleLeft
} from '@tabler/icons-react'
import { useSupabase } from '@packages/supabase'
import { useLocation } from 'react-router'
import { Outlet, useNavigate } from 'react-router'
import { TenantsProvider } from '@/lib/tenantsContext'

const NavItem = (props: any) => {
  return (
    <div
      onClick={props.onClick}
      className={`flex flex-row ${props.active ? 'bg-sky-100/70 text-black' : 'bg-white/10 text-white hover:bg-sky-200/50'} cursor-pointer p-3`}
    >
      <div className={'w-[30px]'}>{props.icon}</div>
      <p>{props.label || props.children}</p>
    </div>
  )
}

export const Layout = () => {
  const navigate = useNavigate()
  const { supabase } = useSupabase()
  const location = useLocation()

  const handleLogout = async () => {
    await supabase.auth.signOut()
    navigate('/')
  }

  return (
    <TenantsProvider>
      <div className="flex h-full min-h-screen flex-row gap-5">
        <Stack
          role={'navigation'}
          className={'w-[220px] bg-black/10 text-white'}
        >
          <Group className={'justify-center p-3'}>
            <H2 className={'p-2'}>ADMIN</H2>
          </Group>

          <Stack className={'flex-1 gap-0 text-black'}>
            <NavItem
              label={'Dashboard'}
              active={location.pathname === '/'}
              onClick={() => navigate('/')}
              icon={<IconHome size={20} stroke={1.5} />}
            />

            <NavItem
              label={'Tenants'}
              active={location.pathname.startsWith('/tenants')}
              onClick={() => navigate('/tenants')}
              icon={<IconUser size={20} stroke={1.5} />}
            />

            <NavItem
              label={'Features'}
              active={location.pathname === '/features'}
              onClick={() => navigate('/features')}
              icon={<IconToggleLeft size={20} stroke={1.5} />}
            />

            <NavItem
              label={'Notifications'}
              active={location.pathname === '/notifications'}
              onClick={() => navigate('/notifications')}
              icon={<IconBell size={20} stroke={1.5} />}
            />

            <NavItem
              label={'Plan management'}
              active={
                location.pathname === '/plans' ||
                location.pathname === '/stripe'
              }
              onClick={() => navigate('/plans')}
              icon={<IconCreditCard size={16} stroke={1.5} />}
            />

            <NavItem
              label={'Prompts'}
              active={location.pathname === '/prompts'}
              onClick={() => navigate('/prompts')}
              icon={<IconCode size={20} stroke={1.5} />}
            />

            <NavItem
              label={'Schemas'}
              active={location.pathname === '/schemas'}
              onClick={() => navigate('/schemas')}
              icon={<IconFileText size={20} stroke={1.5} />}
            />

            <NavItem
              label={'Demo Content'}
              active={location.pathname === '/demo-content'}
              onClick={() => navigate('/demo-content')}
              icon={<IconDatabase size={20} stroke={1.5} />}
            />

            <NavItem
              label={'Preferences'}
              active={location.pathname === '/preferences'}
              onClick={() => navigate('/preferences')}
              icon={<IconBooks size={20} stroke={1.5} />}
            />

            <NavItem
              label={'Security'}
              active={location.pathname === '/security'}
              onClick={() => navigate('/security')}
              icon={<IconKey size={20} stroke={1.5} />}
            />

            <div className="flex-1" />

            <NavItem
              label={'Logout'}
              active={false}
              onClick={handleLogout}
              icon={<IconLogout size={20} stroke={1.5} />}
            />
          </Stack>
        </Stack>
        <Stack w={'100%'} p={'xl'} className="text-white">
          <Outlet />
        </Stack>
      </div>
    </TenantsProvider>
  )
}
